import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NewsFeedEditMobileDialogComponent } from './edit-mobile-dialog.component';
import { ModuleType } from '@fi-shared/types/module-type';
import { PostModel } from '@fi-shared/models';
import { FiDialogsService } from '@fi-shared/fi-dialogs';

@Injectable()
export class FiNewsFeedEditMobileService {
    constructor(private fiDialogsService: FiDialogsService) {}

    openMobilePostEditor(post: PostModel): MatDialogRef<NewsFeedEditMobileDialogComponent> {
        const modalRef = this.fiDialogsService.open(NewsFeedEditMobileDialogComponent, {
            data: {
                post: post,
                moduleType: post.IsForumPost ? ModuleType.ForumPost : ModuleType.Post,
                searchObjectId: undefined,
            },
            panelClass: 'fi-news-feed-edit-mobile-dialog-panel',
        });

        this.fiDialogsService.attachStateFullMatDialog(modalRef);
        return modalRef;
    }
}
